module.exports = __webpack_public_path__ + "static/media/chores.b8bc3d7b.SVG";